import { lazy } from "react";
import { createBrowserRouter } from "react-router";
import AdminRoute from "@/components/auth/AdminRoute";

const MainLayout = lazy(() => import("@/layouts/Main"));
const OnboardingLayout = lazy(() => import("@/layouts/Onboarding"));
const Onboarding = lazy(() => import("@/pages/Onboarding"));
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const FirstReview = lazy(() => import("@/pages/FirstReview"));
const FirstReviewSample = lazy(() => import("@/pages/FirstReviewSample"));
const Reports = lazy(() => import("@/pages/Reports"));
const FirstReviewReport = lazy(() => import("@/pages/Reports/FirstReviewReport"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const MyAccount = lazy(() => import("@/pages/MyAccount"));
const Insights = lazy(() => import("@/pages/Insights"));
const Products = lazy(() => import("@/pages/Products"));
const ProductPage = lazy(() => import("@/pages/ProductPage"));
const Socials = lazy(() => import("@/pages/Socials"));
const Integrations = lazy(() => import("@/pages/Integrations"));
const IntegrationsShopify = lazy(() => import("@/pages/Integrations/Shopify"));
const MagentoLogin = lazy(() => import("@/pages/Integrations/Magento/Login"));
const WooCommerce = lazy(() => import("@/pages/Integrations/WooCommerce"));
const Meta = lazy(() => import("@/pages/Integrations/Meta"));
const Ga4 = lazy(() => import("@/pages/Integrations/Ga4"));
const DashboardTest = lazy(() => import("@/pages/Dashboard/DashboardTest"));
const AdminPanel = lazy(() => import("@/pages/AdminPanel"));
const AdminUserDetailsPage = lazy(() => import("@/pages/AdminPanel/UserDetailsPage"));
const FeatureFlags = lazy(() => import("@/pages/AdminPanel/FeatureFlags"));

const TigimRoutes = createBrowserRouter([
  {
    path: "/sign-up",
    Component: Onboarding
  },
  {
    path: "/dt",
    Component: DashboardTest
  },
  {
    path: "/pp",
    Component: Products
  },
  {
    path: "/pp/:productSlug",
    Component: ProductPage
  },
  {
    path: "/first-review-sample",
    Component: OnboardingLayout,
    children: [
      {
        path: "/first-review-sample",
        Component: FirstReviewSample
      }
    ]
  },
  {
    path: "/",
    Component: MainLayout,
    children: [
      {
        index: true,
        Component: Integrations
      },
      {
        path: "/first-review/:url",
        Component: FirstReview
      },
      {
        path: "/first-review-sample",
        Component: FirstReviewSample
      },
      {
        path: "/myaccount",
        Component: MyAccount
      },
      {
        path: "/dashboard",
        Component: Dashboard
      },
      {
        path: "/dashboard/:current/:currentStart/:currentEnd",
        Component: Dashboard
      },
      {
        path: "/dashboard/:current/:currentStart/:currentEnd/:previous/:previousStart/:previousEnd",
        Component: Dashboard
      },
      {
        path: "/reports",
        Component: Reports
      },
      {
        path: "/reports/first-review",
        Component: FirstReviewReport
      },
      {
        path: "/products",
        Component: Products
      },
      {
        path: "/product-page/:productSlug",
        Component: ProductPage
      },
      {
        path: "/socials",
        Component: Socials
      },
      {
        path: "/socials/:currentStart/:currentEnd",
        Component: Socials
      },
      {
        path: "/integrations/spf?code=:code&hmac=:hmac&host=:host&shop=:shop&state=:state&timestamp=:timestamp",
        Component: IntegrationsShopify
      },
      {
        path: "/integrations/spf",
        Component: IntegrationsShopify
      },
      {
        path: "/integrations/magento/login?oauth_consumer_key=:oauth_consumer_key&success_call_back=:success_call_back",
        Component: MagentoLogin
      },
      {
        path: "/integrations/magento/login",
        Component: MagentoLogin
      },
      {
        path: "/integrations/meta?code=:code&state=:state",
        Component: Meta
      },
      {
        path: "/integrations/meta",
        Component: Meta
      },
      {
        path: "/integrations/ga?state=:state&code=:code&scope=:scope",
        Component: Ga4
      },
      {
        path: "/integrations/ga",
        Component: Ga4
      },
      {
        path: "/integrations/woocommerce",
        Component: WooCommerce
      },
      {
        path: "/integrations",
        Component: Integrations
      },
      {
        path: "/insights",
        Component: Insights
      },
      {
        path: "/admin",
        element: (
          <AdminRoute>
            <AdminPanel />
          </AdminRoute>
        )
      },
      {
        path: "/admin/users/:id",
        Component: () => (
          <AdminRoute>
            <AdminUserDetailsPage />
          </AdminRoute>
        )
      },
      {
        path: "/admin/feature-flags",
        element: (
          <AdminRoute>
            <FeatureFlags />
          </AdminRoute>
        )
      },
      {
        path: "/*",
        Component: NotFound
      }
    ]
  }
]);

export default TigimRoutes;
